import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

class InputFile extends Component {
  static propTypes = {
    accept: PropTypes.array,
    className: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    inputRef: PropTypes.func.isRequired,
    maxSize: PropTypes.func,
    bottomLabel: PropTypes.string,
  }

  state = {
    filename: '',
    error: null,
  }

  handleChange = (event) => {
    const { onChange, translate, maxSize } = this.props
    const { files } = event.target

    let filename = translate('input-file.none.selected')
    let error

    if (files && files.length) {
      files.forEach((e) => {
        if (maxSize && e.size > maxSize) {
          error = translate('input-file.max.size')
        }
      })

      if (files.length > 1) {
        filename = `${files.length} ${translate('input-file.selected.files')}`
      } else {
        filename = files[0].name
      }
    }

    this.setState({ filename, error })
    if (!error) {
      onChange(event)
    }
  }

  render() {
    const {
      id,
      name,
      translate,
      className,
      accept = [],
      inputRef,
      bottomLabel,
    } = this.props

    const finalId = id || name

    const cls = classNames('input-file', className)

    const { error, filename } = this.state

    return (
      <div className={cls}>
        <input
          className={`input ${error && 'error'}`}
          placeholder={translate('input-file.select-file')}
          value={error || filename}
          disabled
        />

        <div className='upload'>
          <input
            id={finalId}
            type='file'
            name={name}
            className='upload-input'
            onChange={this.handleChange}
            accept={accept.join()}
            ref={inputRef}
          />

          <label htmlFor={finalId} className='upload-label'>
            {translate('input-file.upload')}
          </label>
        </div>

        {bottomLabel && <i className='bottomLabel'>{bottomLabel}</i>}
      </div>
    )
  }
}

export default InputFile
